import { ITheme } from './types';
const theme: ITheme = {
    colors: {
        emerald10: '#F2F7F6',
        emerald20: '#00634E',
        emerald30: '#025F4C',
        emerald40: '#066066',
        emerald45: '#046C57',
        emerald50: '#035645',

        grass10: "#BCDD33",
        
        chrome10: "#FDD506",
        
        grey10: "#FAFAFA",
        grey20: "#d4d4d4",
        grey30: "#858484",
        grey40: "#4B4B4B",
        grey50: "#595959",

        amethyst10: "#685F80",

        turquoise10: "#36D6C3",
        planRed: "#FF8080",
        
        white: '#fff',
        
    },
    fontFamily: {
        garamond: 'EB Garamond',
        roboto: 'Roboto',
        workSans: 'Work Sans'
    },
    fontSizes: {
        landing: '2.2rem',
        title: '1rem',
        heading: '18px',
        body: '14px',
        sectionHeading: '10px',
        label: '12px'
    },
    fontWeights: {
        light: 300,
        regular: 400,
        medium: 500,
        semibold: 600,
    },
    borderRadius: {
        cardRadius: '0.7rem',
        buttonRadius:"0.85rem",
    },
    height: {
        navbarHeight:'10vh'
    },
    breakpoints: {
        breakpoint0: "1300px",
        breakpoint1: "1000px",
        breakpoint2: "580px",
        breakpoint3: "460px",
        breakpoint4: "720px",
        breakpoint5: "410px",
        breakpoint6: "370px",
        breakpoint7: "350px",
    },
    icons:{
        downArrow: "@images/common/dropdown-arrow.svg",
        check:"@icons/svg",
    }
};

export default theme;
